import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ConfigProvider } from 'antd';
import Main from '../utility/Main';
import { Mainlayout } from '../ui/ot';
import Label_language from './../language'
import SmartTaskScheduling from './smart_task_scheduling'
import SmartTaskSchedulingTaskCategory from './smart_task_scheduling_task_category'
import SmartTaskSchedulingTaskLabel from './smart_task_scheduling_task_label'
import SmartTaskSchedulingTaskPriority from './smart_task_scheduling_task_priority'
import SmartTaskSchedulingTaskStatus from './smart_task_scheduling_task_status'
import SmartTaskSchedulingTaskReplyCategory from './smart_task_scheduling_task_reply_category'
import SmartTaskSchedulingTaskReply from './smart_task_scheduling_task_reply'
import SmartTaskSchedulingTask from './smart_task_scheduling_task'
// import FlowData from './components/FlowData/FlowData';

import MainOutlet from "./MainOutlet";
import Competency from './competency';
import CompetencyTaskMatching from "./competency_task_matching";
import AiModuleCategory from './personal_smart_assistant_ai_module_category'
import AiModule from './personal_smart_assistant_ai_module'
import PersonalRequirement from './personal_smart_assistant_personal_requirement'
import AiRentalAccount from './personal_smart_assistant_ai_rental_account'
import RiskCategory from './ai_risk_management_risk_category'
import RiskReplyMethod from './ai_risk_management_risk_reply_method'
import Risk from './ai_risk_management_risk'
import RiskCorrespondingResource from './ai_risk_management_risk_corresponding_resource'
import SOP from '../ai_flow_automation/views/sop'
import SOPDetail from '../ai_flow_automation/views/sop_detail'
import SOPDisplay from '../ai_flow_automation/views/sop_display'
import SOPDisplaySelf from '../ai_flow_automation/views/sop_display_self'

const label_language = Label_language.pmis
const { ConfigContext } = ConfigProvider
const MainRoute = () => {
    const configContext = useContext(ConfigContext)
    const language = configContext.locale.locale
    return (
        <Routes>
            <Route path={''} element={
                <Mainlayout />
            } >
                <Route path={''} element={
                    <Main
                        language={label_language}
                    />
                } />
                <Route path={'smartTaskSchedulingTask'} element={
                    <SmartTaskSchedulingTask />
                } />
                <Route path={'smartTaskSchedulingTaskReply'} element={
                    <SmartTaskSchedulingTaskReply />
                } />
                <Route path={'smartTaskSchedulingTaskReplyCategory'} element={
                    <SmartTaskSchedulingTaskReplyCategory />
                } />
                <Route path={'smartTaskSchedulingTaskStatus'} element={
                    <SmartTaskSchedulingTaskStatus />
                } />
                <Route path={'smartTaskSchedulingTaskPriority'} element={
                    <SmartTaskSchedulingTaskPriority />
                } />
                <Route path={'smartTaskSchedulingTaskLabel'} element={
                    <SmartTaskSchedulingTaskLabel />
                } />
                <Route path={'smartTaskSchedulingTaskCategory'} element={
                    <SmartTaskSchedulingTaskCategory />
                } />
                {/* <Route path={'riskCorrespondingResource'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.riskCorrespondingResource[language],
                                    path: '/pmis/riskCorrespondingResource'
                                },
                            ]}
                            title={label_language.children.pmis.children.riskCorrespondingResource[language]}
                        >
                            <RiskCorrespondingResource />
                        </Main_layout>
                    </>} />
                <Route path={'risk'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.risk[language],
                                    path: '/pmis/risk'
                                },
                            ]}
                            title={label_language.children.pmis.children.risk[language]}
                        >
                            <Risk />
                        </Main_layout>
                    </>} />
                <Route path={'riskReplyMethod'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.riskReplyMethod[language],
                                    path: '/pmis/riskReplyMethod'
                                },
                            ]}
                            title={label_language.children.pmis.children.riskReplyMethod[language]}
                        >
                            <RiskReplyMethod />
                        </Main_layout>
                    </>} />
                <Route path={'riskCategory'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.riskCategory[language],
                                    path: '/pmis/riskCategory'
                                },
                            ]}
                            title={label_language.children.pmis.children.riskCategory[language]}
                        >
                            <RiskCategory />
                        </Main_layout>
                    </>} />
                <Route path={'aiRentalAccount'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.aiRentalAccount[language],
                                    path: '/pmis/aiRentalAccount'
                                },
                            ]}
                            title={label_language.children.pmis.children.aiRentalAccount[language]}
                        >
                            <AiRentalAccount />
                        </Main_layout>
                    </>} />
                <Route path={'personalRequirement'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.personalRequirement[language],
                                    path: '/pmis/personalRequirement'
                                },
                            ]}
                            title={label_language.children.pmis.children.personalRequirement[language]}
                        >
                            <PersonalRequirement />
                        </Main_layout>
                    </>} />
                <Route path={'aiModule'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.aiModule[language],
                                    path: '/pmis/aiModule'
                                },
                            ]}
                            title={label_language.children.pmis.children.aiModule[language]}
                        >
                            <AiModule />
                        </Main_layout>
                    </>} />
                <Route path={'aiModuleCategory'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.aiModuleCategory[language],
                                    path: '/pmis/aiModuleCategory'
                                },
                            ]}
                            title={label_language.children.pmis.children.aiModuleCategory[language]}
                        >
                            <AiModuleCategory />
                        </Main_layout>
                    </>} /> */}
                {/* <Route path={'aiProcessAutomation'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.aiProcessAutomation[language],
                                    path: '/pmis/aiProcessAutomation'
                                },
                            ]}
                            title={label_language.children.pmis.children.aiProcessAutomation[language]}
                        >
                            <FlowData />
                        </Main_layout>
                    </>} /> */}
                {/* <Route path={'smartTaskScheduling'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.smartTaskScheduling[language],
                                    path: '/pmis/smartTaskScheduling'
                                },
                            ]}
                            title={label_language.children.pmis.children.smartTaskScheduling[language]}
                        >
                            <SmartTaskScheduling />
                        </Main_layout>
                    </>} />
                <Route path={'CompetencyMatching'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.CompetencyMatching[language],
                                    path: '/pmis/Competency'
                                },
                            ]}
                            title={label_language.children.pmis.children.CompetencyMatching[language]}
                        >
                            <Competency />
                        </Main_layout>
                    </>} />
                <Route path={'Competency'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.Competency[language],
                                    path: '/pmis/Competency'
                                },
                            ]}
                            title={label_language.children.pmis.children.Competency[language]}
                        >
                            <Competency />
                        </Main_layout>
                    </>} />
                <Route path={'CompetencyTaskMatching'} element={
                    <>
                        <Main_layout
                            path={[
                                {
                                    name: label_language[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis[language],
                                    path: '/pmis'
                                },
                                {
                                    name: label_language.children.pmis.children.CompetencyTaskMatching[language],
                                    path: '/pmis/CompetencyTaskMatching'
                                },
                            ]}
                            title={label_language.children.pmis.children.CompetencyTaskMatching[language]}
                        >
                            <CompetencyTaskMatching />
                        </Main_layout>
                    </>} /> */}

                <Route path={'sop'} element={
                    <SOP />
                } />
                <Route path={'sop_detail'} element={
                    <SOPDetail />
                } />
                <Route path={'sop_display'} element={
                    <SOPDisplay self={false}/>
                } />
                <Route path={'sop_display_self'} element={
                    <SOPDisplaySelf />
                } />
            </Route>
        </Routes >
    );
}
export default MainRoute;

